import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var QuaterlyTargetTwoRes;
export const QuaterlyTargetTwoTodo = createAsyncThunk('QuaterlyTargetTwo', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'quarterly_target_list',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "iquater_id": "2",
                "iyear": '',
                "fin_year": localStorage.getItem('vfin_year').toString()

            }
        })
        return QuaterlyTargetTwoRes = res.data

    } catch (error) {
        return QuaterlyTargetTwoRes = error.response.data
    }
});

const QuaterlyTargetTwoSlice = createSlice({
    name: 'QuaterlyTargetTwo',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(QuaterlyTargetTwoTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(QuaterlyTargetTwoTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default QuaterlyTargetTwoSlice.reducer; 